<div class="page-innder-body portlet light" [ngClass]="{'p-3':!isAuthenticated}">

  <div class="portlet-body mt-5">
    <div class="border-bottom">
      <p class="text-muted">{{ 'deleteMetaData.intro' | transloco }}</p>
    </div>
    <div class="d-flex mt-4">
      <div class="interaction-section d-flex flex-column justify-content-center align-items-center">
        <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" class="img-fluid mb-4"
          style="max-width: 200px;" [alt]="'deleteMetaData.logo' | transloco">
          <h3 class="text-white">{{ 'deleteMetaData.welcome' | transloco }}</h3>
          <p class="text-white">{{ 'deleteMetaData.followInstructionsFacebook' | transloco }}</p>
          <!-- <p class="text-white" *ngIf="platform === 'instagram'">Please follow the instructions to delete your
          Instagram
        account data.</p> -->
      </div>
      <div class="card-container d-flex justify-content-center align-items-center">
        <div class="card border-0 shadow-lg w-100" style="max-width: 800px;">
          <div class="d-flex justify-content-between">
            <div>
              <h3 class="mb-2">{{ 'deleteMetaData.deleteMetadata' | transloco }} </h3>
            </div>
            @if (platform === 'instagram') {
              <div>
                <img src="assets/images/instagram.png" class="img-fluid" style="max-width: 40px;"
                  [alt]="'deleteMetaData.instagramLogo' | transloco">
                </div>
              } @else {
                <div>
                  <img src="assets/images/facebook.png" class="img-fluid" style="max-width: 40px;"
                    [alt]="'deleteMetaData.facebookLogo' | transloco">
                  </div>
                }

              </div>

              <div class="row">
                <div class="col-md-4 d-flex flex-column align-items-center mt-2">
                  <img [src]="logoImgUrl ? logoImgUrl : 'assets/images/No-Image.png'"
                    class=" mb-3 rounded-cube" style="height: 150px; object-fit: cover;">
                    <h5 class="mb-1">{{ firstName }}</h5>
                  </div>
                  <div class="col-md-8 d-flex flex-column justify-content-between">
                    <div>
                      <div class="mb-3">
                        <label class="form-label fw-bold">{{ 'deleteMetaData.enterUsername' | transloco }}</label>
                        <input type="text" class="form-control" [(ngModel)]="username" >
                      </div>
                      <div class="mb-3">
                        <label class="form-label fw-bold">{{ 'deleteMetaData.enterPassword' | transloco }}</label>
                        <input type="password" class="form-control" [placeholder]="'deleteMetaData.enterYourPassword' | transloco"
                          [(ngModel)]="password">
                        </div>
                      </div>
                      <!-- <ng-container *ngIf="platform === 'instagram'; else facebookButton">
                      <button class="btn btn-danger w-100 mb-3" [disabled]="!isFormValid()"
                        (click)="deleteInstagramMetaData()">
                        Delete
                      </button>
                    </ng-container> -->
                    <!-- <ng-template #facebookButton> -->
                    <button class="btn btn-danger w-100 mb-3" [disabled]="!isFormValid()"
                      (click)="deleteFacebookMetaData()">
                      {{ 'deleteMetaData.delete' | transloco }}
                    </button>
                  <!-- </ng-template> -->
                </div>
              </div>
              <div class="mt-4">
                <p class="text-muted">
                  {{ 'deleteMetaData.facebookWarning' | transloco }}
                </p>
                <!-- <p class="text-muted" *ngIf="platform === 'instagram'">
                By deleting your Instagram account data, you will permanently lose access to all your
                posts, shares,
                and interactions. This action cannot be undone. Please ensure that you have backed up
                any important
                information before proceeding. If you have any questions or need assistance, please
                contact our
                support team.
              </p> -->
              <p class="text-muted">
                {{ 'deleteMetaData.facebookIrretrievable' | transloco }}
              </p>
              <!-- <p class="text-muted" *ngIf="platform === 'instagram'">
              Once your Instagram account data is deleted, you will need to create a new account if
              you wish to
              use our services again, as all your previous data will be irretrievable.
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <p-dialog header="Confirm" [(visible)]="isInstagramAccountDeleteConfirmationDailogVisible" [style]="{'width': '350px'}"
[modal]="true" (onHide)="onCloseInstagramMetadataConfirmationDailog()">
<div class="d-flex">
  <i class="pi pi-exclamation-triangle pt-1 me-2 text-danger"></i>
  <div>Are you sure you want to delete your account? Clicking "Yes" will permanently delete all your metadata.</div>
</div>
<div class="d-flex justify-content-end">
  <button type="button" pButton icon="pi pi-times" label="No" class="p-button-secondary p-button-outlined"
  (click)="onCloseInstagramMetadataConfirmationDailog()"></button>
  <button type="button" pButton icon="pi pi-check" label="Yes" class="p-button-danger ms-2"
  (click)="deleteInstagramAccounts()"></button>
</div>
</p-dialog> -->

<p-dialog [header]="'deleteMetaData.confirm' | transloco" [(visible)]="isFacebookAccountDeleteConfirmationDailogVisible" [style]="{'width': '350px'}"
  [modal]="true" (onHide)="onCloseFacebookMetadataConfirmationDailog()">
  <div class="d-flex mb-2">
    <i class="pi pi-exclamation-triangle pt-1 me-2 text-danger"></i>
    <div>{{ 'deleteMetaData.confirmDeleteMessage' | transloco }}</div>
  </div>
  <div class="d-flex justify-content-end">
    <button type="button" pButton icon="pi pi-times" [label]="'deleteMetaData.no' | transloco" class="p-button-secondary p-button-outlined"
    (click)="onCloseFacebookMetadataConfirmationDailog()"></button>
    <button type="button" pButton icon="pi pi-check" [label]="'deleteMetaData.yes' | transloco" class="p-button-danger ms-2"
    (click)="deleteFacebookAccounts()"></button>
  </div>
</p-dialog>